import {
    deleteTrainingTemplate,
    saveTrainingTemplate,
    selectTrainingTemplate,
    setSearchText,
    updateTrainingTemplate
} from 'training/actions';
import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import autobind from 'autobind-decorator';
import Question from 'training/components/Question';
import {
    Input,
    InputGroup,
    InputGroupAddon,
    Button,
    Col, Row,
    Label
} from 'reactstrap'

@connect(
    state => ({
        trainingTemplate: state.training.selectedTrainingTemplate,
    }),
    dispatch => ({
        update: (training) => dispatch(updateTrainingTemplate(training)),
        save:   (training) => dispatch(saveTrainingTemplate(training)),
        select: (training) => dispatch(selectTrainingTemplate(training)),
        delete: (training) => dispatch(deleteTrainingTemplate(training)),
        search: (searchText) => dispatch(setSearchText(searchText))
    })
)
export class TrainingDetails extends Component {

    state = {
        openQuestion: ''
    }

    @autobind
    setOpenQuestion(key) {
        this.setState({
            openQuestion: key
        })
    }

    @autobind
    openQuestion() {
        return this.state.openQuestion
    }

    @autobind
    updateTrainingTemplate() {
        this.props.update(this.props.trainingTemplate);
    }

    @autobind
    updateTrainingName(e) {
        this.props.update({
            ...this.props.trainingTemplate,
            name: e.target.value
        });
    }

    @autobind
    save() {
        this.props.save()
    }

    @autobind
    addQuestion(questionList) {
        const trainingTemplate = {
            ...this.props.trainingTemplate,
            data: [
                ...questionList,
                {
                    idx: questionList.length + 1,
                    text: 'Neue Frage',
                    answers: []
                }
            ]
        }
        this.props.select(trainingTemplate)
    }

    @autobind
    updateQuestion(question) {
        const trainingTemplate = {
            ...this.props.trainingTemplate,
        }
        const questionList = trainingTemplate.data.map(
            (q) => {
                if(q.idx === question.idx) {
                    return question
                }
                return q
            }
        )
        this.props.update({
            ...trainingTemplate,
            data: questionList
        })
    }

    @autobind
    deleteQuestion(question) {
        const questionList = this.props.trainingTemplate.data.filter(
            q => q.idx !== question.idx
        );
        this.props.update({
            ...this.props.trainingTemplate,
            data: questionList
        })
    }


    render() {
        const {trainingTemplate} = this.props;
        if (!trainingTemplate)
            return null;
        const data = trainingTemplate.data;
        const questionList = Array.isArray(data) ? data : [];
        const totalPoints = questionList.reduce(
            (acc, curr) => acc + curr.points, 0
        )
        return <Fragment>
            <InputGroup>
                <InputGroupAddon addonType='prepend'>
                    <Button color={'primary'} onClick={() => this.props.select(null)}>
                        <i className={'fa fa-times'}> </i>
                    </Button>
                </InputGroupAddon>
                <Input value={trainingTemplate.name} onChange={this.updateTrainingName} onBlur={this.save}/>
                <InputGroupAddon addonType='append'>
                    <Button color={'danger'} onClick={() => this.props.delete(trainingTemplate)}>
                        <i className={'fa fa-trash'}> </i>
                    </Button>
                </InputGroupAddon>
            </InputGroup>
            <br/>
            <Button color={'primary'} onClick={() => this.addQuestion(questionList)}>
                <i className={'fa fa-plus'}> </i> Frage hinzufügen
            </Button>
            <br/>
            {
                questionList.map(
                    (question, idx) => (
                        <Question
                            key={`training_question_${trainingTemplate.id}_${idx}`}
                            dkey={`training_question_${trainingTemplate.id}_${idx}`}
                            question={question}
                            updateQuestion={this.updateQuestion}
                            deleteQuestion={() => this.deleteQuestion(question)}
                            save={this.save}
                            openQuestion={this.openQuestion}
                            setOpenQuestion={this.setOpenQuestion}
                        />)
                )
            }
            <br/>
            <Row>
                <Col sm={1}>
                    <Label>Gesamtpunktzahl</Label>
                    <Input defaultValue={totalPoints} type='number' disabled/>
                </Col>
            </Row>
        </Fragment>
    }
}
